export default __webpack_public_path__ + "static/media/PlacementAgreement.712bc44e.svg";